import { cx } from "../../utils";

const Card = ({
  title,
  subtitle,
  action,
  className = "",
  bodyClassName = "",
  padded = true,
  children,
}) => (
  <div className={cx("bg-white border border-ink-200/70 rounded-2xl shadow-card", className)}>
    {(title || action) && (
      <div className="flex items-start justify-between gap-3 px-5 pt-5 pb-3">
        <div className="min-w-0">
          {title && (
            <h3 className="text-[13px] font-semibold text-ink-900 tracking-tight">{title}</h3>
          )}
          {subtitle && <p className="text-xs text-ink-500 mt-0.5">{subtitle}</p>}
        </div>
        {action && <div className="shrink-0">{action}</div>}
      </div>
    )}
    <div className={cx(padded && "p-5", (title || action) && "pt-2", bodyClassName)}>
      {children}
    </div>
  </div>
);

export default Card;
